import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=11a03949&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"
import style0 from "./permissions.vue?vue&type=style&index=0&id=11a03949&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a03949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a03949')) {
      api.createRecord('11a03949', component.options)
    } else {
      api.reload('11a03949', component.options)
    }
    module.hot.accept("./permissions.vue?vue&type=template&id=11a03949&scoped=true", function () {
      api.rerender('11a03949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/list/permissions/permissions.vue"
export default component.exports